<template>
  <div class="add_apply">
    <div class="bx_item">
      <div class="fs-40">服务说明</div>
      <div class="box fs-28 rich-text" v-html="instype_explain"></div>
    </div>
    <template>
      <div class="bx_item">
        <div class="fs-40 mt-50">
          设备正面照<span style="color: #e86161">*</span>
        </div>
        <div class="box fs-28">
          <p>1.请在拨号界面输入*#06#串码或序列号界面拍照；</p>
          <p>2.请参考示例图拍摄，确保手机拍摄完整，串码一致</p>
        </div>
      </div>
      <pic-uploader @change="(url) => (formData.tem_img = url)" style="padding-left: 15px"
        :example="require(`@/assets/images/examplePic/ershouzhengmian.png`)" :src="formData.tem_img"></pic-uploader>
    </template>

    <template>
      <div class="bx_item">
        <div class="fs-40 mt-50">
          验机报告（ERP截图）<span style="color: #e86161">*</span>
        </div>
      </div>
      <pic-uploader @change="(url) => (formData.tem_erp = url)" style="padding-left: 15px"
        :example="require(`@/assets/images/examplePic/ershouExample.jpg`)" :src="formData.tem_erp"></pic-uploader>
    </template>

    <div class="bx_item form_box">
      <div class="fs-40 mt-50">
        用户信息<span style="color: #e86161">*</span>
      </div>
    </div>
    <van-form validate-first @submit="onSubmit" class="form_wid">
      <!-- 姓名 -->
      <van-field class="form_wid" v-model="formData.name" label="姓名" input-align="right" placeholder="请输入机主姓名" />

      <!-- 手机号 -->
      <van-field class="form_wid" type="tel" v-model="formData.phone" label="手机号码" maxlength="11" input-align="right"
        placeholder="请输入11位机主手机号" />

      <!-- IMEI号 -->
      <scan-code title="IMEI号或序列号" placeholder="请输入手机IMEI码或扫码" v-model="formData.imei" maxlength="24"
        @myInput="imitInput">
      </scan-code>

      <!-- //权益类型 -->
      <fieldPiker label="权益类型" placeholder="请选择权益类型" title="权益类型选择" :columns="insuranceTypeData" valueKey="instype_name"
        :selectValue="showName.instype_name" @getMessage="setSelectValue($event, 'instype_name')">
      </fieldPiker>

      <template>
        <template>
          <div style="display: flex;align-items: center;">
            <van-field class="form_wid" type="text" v-model="formData.card_secret" label="保卡卡密" label-width="15em"
              input-align="right" placeholder="请输入6-12位保卡卡密" />
            <span @click="getRandomCarmiShow" class="random_carmi">在线生成</span>
          </div>

        </template>

      </template>

      <select-search-cell title="手机品牌" placeholder="请选择手机品牌" v-model="formData.brand_id" :options="brandList"
        id-key="brand_id" label-key="brand" @change="($event) => {
          setSelectValue($event, 'brand');
        }
        ">
      </select-search-cell>


      <select-search-cell title="手机型号" placeholder="请输入查询或选择型号" v-model="formData.model_id" :options="modelList"
        id-key="model_id" label-key="model_name" @click.native="selectRepairer" @change="($event) => {
          setSelectValue($event, 'model_name');
        }
        "></select-search-cell>

      <!-- //手机规格 -->
      <fieldPiker label="手机规格" placeholder="请输入查询或选择规格" title="手机规格选择" :columns="ramSizeList"
        :selectValue="this.showName.ram_size" valueKey="ram_size" @getMessage="setSelectValue($event, 'ram_size')"
        @click.native="selectRepairer2">
      </fieldPiker>

      <!-- //网络制式 -->
      <fieldPiker label="网络制式" placeholder="请选择网络制式" title="网络制式选择" :columns="netList"
        :selectValue="this.showName.net_name" valueKey="net_name" @getMessage="setSelectValue($event, 'net_name')">
      </fieldPiker>

      <money v-model="formData.bare_price" title="购机价格" :placeholder="'购机价格'" />

      <div v-if="this.showName.instype_name" class="access g-flex-ac g-flex-jc mt-20 mt-50">
        <img @click="protocol = true" v-if="protocol === false" src="../../assets/images/icon_gx_wx.png" alt="" />
        <img @click="protocol = false" v-if="protocol === true" src="../../assets/images/icon_gx.png" alt="" />
        <span class="ml-10" style="color: #999999">已阅读并接受</span>
        <span style="color: #577bb5" @click="showText = true">
          <span v-if="this.showName.instype_name">《{{ this.showName.instype_name }}》</span>
        </span>
      </div>
      <!-- 提交注册 -->
      <div class="btn_sub">
        <my-button class="confirm-btn" :type="protocol ? 'primary' : 'default'" :disabled="!protocol"
          native-type="submit">提交申请
        </my-button>
      </div>
    </van-form>
    <!-- 随机生成卡密弹框 -->
    <van-popup v-model="randomCarmiShow" round position="bottom">
      <van-picker title="在线生成卡密" show-toolbar :columns="randomCarmiColumns" @cancel="randomCarmiShow = !randomCarmiShow"
        @confirm="randomCarmiConfirm" />
    </van-popup>
    <!-- 协议弹框 -->
    <van-popup round v-model="showText">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="wra_tittle" v-if="this.showName.instype_name">
            {{ this.showName.instype_name }}服务协议
          </div>
          <div class="text rich-text" v-html="decodeHTML(instype_agree)"></div>
          <div class="wra_btn" @click="showText = false">知道了</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { decodeHTML } from "@/common/filters";

export default {
  computed: {
    decodeHTML() {
      return (str) => {
        return decodeHTML(str);
      };
    },
  },
  data() {
    return {
      instype_explain: '', //保险说明
      insuranceTypeData: [],
      randomCarmiShow: false,
      randomCarmiColumns: [],
      brandList: [],
      modelList: [],
      ramSizeList: [],
      netList: [],
      protocol: false,
      showText: false,
      instype_agree: '',
      //提交上传参数
      formData: {
        tem_img: '',
        tem_erp: '',
        instype_id: 0,
        type: 0,
        name: '',
        phone: '',
        imei: '',
        card_secret: '',
        brand_id: 0,
        model_id: '',
        ram_size: '',
        net_name: '',
        bare_price: '',
      },
      //展示的下拉回显name
      showName: {
        instype_name: "", //权益类型（下拉输入框展示值）
        instype_id: "", //权益类型（下拉输入框展示值）
        brand: "", //品牌
        model_name: "", //品牌下型号
        ram_size: "", //规格
        net_name: "", //网络制式

      },

    };
  },
  watch: {

  },
  mounted() {
    let applyInfo = sessionStorage.getItem("applyInfo");
    if (applyInfo) {
      let data = JSON.parse(applyInfo);
      console.log('applyInfo', data);
      const { tem_img, tem_erp, instype_id, type, name, phone, imei, card_secret,
        brand_id, model_id, ram_size, net_name, bare_price, brand, model_name, order_id } = data.order
      const { instype_name } = data.insurance_type
      this.$http.getPhoneModel({ brand_id, instype_id, card_secret }).then(res => {
        this.modelList = res.data
      })
      this.$http.getPhoneRam({ model_id }).then(res => {
        this.ramSizeList = res.data
      })
      this.formData = { tem_img, tem_erp, instype_id, type, name, phone, imei, card_secret, brand_id, model_id, ram_size, net_name, bare_price, order_id }
      this.showName = { instype_name, instype_id, brand, model_name, ram_size, net_name }
    }
    this.$http.insuranceType({ type: 4 }).then((res) => {
      this.insuranceTypeData = res.data
      const { instype_explain, instype_agree } = res.data[0]
      this.instype_explain = instype_explain
      this.instype_agree = instype_agree
    });
    this.$http.getPhoneBrand().then((res) => {
      const { brandList, netList } = res.data
      this.brandList = brandList
      this.netList = netList
    });
  },
  methods: {
    imitInput(e) {
      this.formData.imei = e.target.value;
    },
    // 随机生成卡密
    getRandomCarmiShow() {
      // 获取列表
      this.$http.getCardName({ instype_id: this.formData.instype_id }).then((res) => {
        console.log(res, "getCardName");
        let columns = []
        if (res.data) {
          columns = res.data.map((column) => ({
            text: column.zifangan,
            value: column.zifang_id,
          }))
        } else {
          columns = []
        }
        this.randomCarmiColumns = columns

        this.randomCarmiShow = true
      });
    },
    randomCarmiConfirm(item, index) {
      console.log(item, index, '8888');
      this.zifang_id = item.value
      // 随机生成卡密
      this.$http.getCard({ instype_id: this.formData.instype_id, zifang_id: this.zifang_id }).then(res => {
        console.log(res, '卡密22');
        this.randomCarmiShow = false
        this.formData.card_secret = res.data.card_secret

      })
    },
    setSelectValue(value, name) {
      console.log('value, name', value, name);
      if (name == 'instype_name') {
        const { instype_name, instype_id } = value
        this.showName.instype_name = instype_name
        this.instype_explain = this.insuranceTypeData.find((le) => le.instype_name == instype_name).instype_explain
        this.instype_agree = this.insuranceTypeData.find((le) => le.instype_name == instype_name).instype_agree
        this.formData.instype_id = instype_id
      } else if (name == 'brand') {
        const { brand_id, instype_id, card_secret } = this.formData
        console.log('formData', this.formData);
        console.log('value', value);
        const { btype } = value
        this.formData.type = btype
        this.$http.getPhoneModel({ brand_id, instype_id, card_secret }).then(res => {
          this.modelList = res.data
        })
      } else if (name == 'model_name') {
        const { model_id } = this.formData
        console.log('formData', this.formData);
        this.$http.getPhoneRam({ model_id }).then(res => {
          this.ramSizeList = res.data
        })
      } else if (name == 'ram_size') {
        const { ram_size } = value
        this.showName.ram_size = ram_size
      } else if (name == 'net_name') {
        const { net_name } = value
        this.showName.net_name = net_name
      }

    },
    selectRepairer() {
      if (!this.formData.brand_id) {
        this.$toast("请先选择手机品牌");
      }
    },
    selectRepairer2() {
      if (!this.formData.model_id) {
        this.$toast("请先选择手机型号");
      }
    },
    onSubmit() {
      console.log(this.formData, 'onSubmit');
      console.log(this.showName, 'showName');
      const { ram_size, net_name } = this.showName
      const { order_id } = this.formData
      if (order_id) {
        this.$http.secondhandEditOrder({
          ...this.formData,
          ram_size, net_name
        }).then((res) => {
          console.log(res, "submit");
          this.$myDialog({
            title: "提交成功",
          });
          this.$router.push("/home");
        });
      } else {
        this.$http.secondhandSetOrder2({
          ...this.formData,
          ram_size, net_name
        }).then((res) => {
          console.log(res, "submit");
          this.$myDialog({
            title: "提交成功",
          });
          this.$router.push("/home");
        });
      }
    },
  }
}
</script>

<style scoped lang="less">
.random_carmi {
  color: rgb(87, 123, 181);
  font-size: 28px;
  width: 140px;
}

::v-deep .van-cell__title {
  flex: 0 3rem;
}

.add_apply {
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 90vw;
    min-height: 30vh;
    max-height: 90vh;
    overflow-y: auto;
    background-color: #f6f8fe;
    border-radius: 20px;

    .wra_tittle {
      font-size: 40px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #323234;
      line-height: 60px;
      width: 90vw;
      margin: 20px auto;
      text-align: center;
    }

    div:nth-child(2) {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      max-height: 70vh;
      overflow-y: scroll;
      width: 80vw;
      margin: 0 auto;
      color: #333333;
      line-height: 44px;
    }

    .wra_btn {
      width: 400px;
      height: 80px;
      background: #577bb5;
      box-shadow: 0px 6px 15px 1px rgba(87, 123, 181, 0.3);
      border-radius: 40px;
      text-align: center;
      color: white;
      line-height: 80px;
      margin: 30px auto;
    }
  }

  .beforeBtn {
    background: #1989fa;
    border: 1px solid #1989fa;
  }

  .afterBtn {
    background: #f0f0f0;
    border: 1px solid #f0f0f0;
    color: #999999;
  }

  ._price {
    /deep/ .van-field__control {
      color: #e86161;
    }
  }

  .img_seach {
    img {
      width: 40px;
    }
  }

  .access {
    text-align: center;
    height: 30px;
    line-height: 30px;

    img {
      width: 28px;
      height: 28px;
    }
  }

  .btn_sub {
    padding: 50px 0;
  }

  .bx_item {
    width: calc(100vw - 60px);
    margin: 20px auto;

    .box {
      line-height: 44px;
      margin-top: 20px;
      padding: 28px 25px;
      background: #f6f8fe;
      border-radius: 16px;
      color: #333333;
      font-family: PingFang SC;
      font-weight: 400;
    }
  }

  .uploder_img {
    height: 332px;
    border: 1px solid red;
  }
}

.not-purchased-from-our-shop {
  .van-cell__title {
    min-width: 8em;
  }
}

.van-switch {
  width: 2.1em;
}

.confirm-btn {
  width: calc(100vw - 150px);
  margin: 30px auto 0;
}

::v-deep .rich-text img {
  max-width: 100%;
}

.videoStyle {
  display: flex;
  justify-content: center;
  margin-bottom: 2em;
}
</style>
